var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 108.00 108.00",
    width: 108,
    height: 108,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#096b60",
    d: " M 95.97 54.00 A 41.97 41.97 0.0 0 0 54.00 12.03 A 41.97 41.97 0.0 0 0 12.03 54.00 A 41.97 41.97 0.0 0 0 54.00 95.97 A 41.97 41.97 0.0 0 0 95.97 54.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80daca",
    d: " M 48.24 59.52 L 40.84 52.12 Q 38.74 50.03 36.28 51.67 Q 35.10 52.45 35.23 54.50 A 2.64 2.63 -69.4 0 0 36.01 56.22 L 46.56 66.73 A 3.15 3.15 0.0 0 0 51.02 66.73 L 71.74 45.98 Q 73.58 44.14 72.37 41.83 Q 72.18 41.47 71.86 41.22 Q 69.43 39.35 67.26 41.53 L 49.29 59.52 Q 48.77 60.05 48.24 59.52"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11202b",
    d: " M 56.43 0.00 C 84.76 2.10 106.21 23.03 108.00 51.43 L 108.00 56.44 C 106.28 84.84 84.88 105.82 56.57 108.00 L 51.57 108.00 C 23.25 105.90 1.77 84.97 0.00 56.57 L 0.00 51.57 C 1.71 23.15 23.12 2.17 51.44 0.00 L 56.43 0.00 Z M 95.97 54.00 A 41.97 41.97 0.0 0 0 54.00 12.03 A 41.97 41.97 0.0 0 0 12.03 54.00 A 41.97 41.97 0.0 0 0 54.00 95.97 A 41.97 41.97 0.0 0 0 95.97 54.00 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b595",
    d: " M 95.97 54.00 A 41.97 41.97 0.0 0 1 54.00 95.97 A 41.97 41.97 0.0 0 1 12.03 54.00 A 41.97 41.97 0.0 0 1 54.00 12.03 A 41.97 41.97 0.0 0 1 95.97 54.00 Z M 48.24 59.52 L 40.84 52.12 Q 38.74 50.03 36.28 51.67 Q 35.10 52.45 35.23 54.50 A 2.64 2.63 -69.4 0 0 36.01 56.22 L 46.56 66.73 A 3.15 3.15 0.0 0 0 51.02 66.73 L 71.74 45.98 Q 73.58 44.14 72.37 41.83 Q 72.18 41.47 71.86 41.22 Q 69.43 39.35 67.26 41.53 L 49.29 59.52 Q 48.77 60.05 48.24 59.52 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: " M 49.29 59.52 L 67.26 41.53 Q 69.43 39.35 71.86 41.22 Q 72.18 41.47 72.37 41.83 Q 73.58 44.14 71.74 45.98 L 51.02 66.73 A 3.15 3.15 0.0 0 1 46.56 66.73 L 36.01 56.22 A 2.64 2.63 -69.4 0 1 35.23 54.50 Q 35.10 52.45 36.28 51.67 Q 38.74 50.03 40.84 52.12 L 48.24 59.52 Q 48.77 60.05 49.29 59.52 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularGreenCheck);
export default __webpack_public_path__ + "static/media/Circular-green-check.9be875945773ec4c0116c960c3d1749b.svg";
export { ForwardRef as ReactComponent };